<template>
  <div>
    <div v-if="showloading" class="text-center">
      <v-progress-circular style="position: absolute; width: 25%; height: 25%; top: 50%; left: 50%; transform: translate(-50%, -50%)" indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
      <LayoutContent>
        <SectionTitle :label="sectionTitle" id="checkout-anchor" />
        <v-stepper alt-labels v-model="currentStep" class="elevation-0">
          <v-stepper-header class="elevation-0 checkout-flow--stepper">
            <template v-for="(step, index) in steps">
              <v-stepper-step :key="`step-${index}`" :complete="currentStep > step" :step="index + 1" style="max-width: 180px">{{ step.title }}</v-stepper-step>
              <v-divider v-if="index < steps.length - 1" :key="`divider-${index}`"></v-divider>
            </template>
          </v-stepper-header>
          <v-stepper-items>
            <!-- step 1 -->
            <v-stepper-content
              step="1"
              :class="{
                'pa-0 px-2': !$vuetify.breakpoint.smAndUp
              }"
            >
              <Checkout :checkoutItems="itemsForCheckout" :orderSummary="orderSummary" :voucherOnlyCart="voucherOnlyCart" :orderCompletedDay="orderCompletedDay" />
            </v-stepper-content>

            <!-- step 2 -->
            <v-stepper-content
              v-if="!voucherOnlyCart"
              step="2"
              :class="{
                'pa-0 px-2': !$vuetify.breakpoint.smAndUp
              }"
            >
              <ArrangeDelivery :isEditCountry="editAddressCountry" :isCheckout="true" />
            </v-stepper-content>

            <!-- step 3 -->
            <v-stepper-content
              :step="voucherOnlyCart ? 2 : 3"
              :class="{
                'pa-0 px-2': !$vuetify.breakpoint.smAndUp
              }"
            >
              <PaymentMethods v-model="selectedMethod" @payment-method="onPaymentMethodSelected" />
            </v-stepper-content>

            <!-- step 4 -->
            <v-stepper-content
              :step="voucherOnlyCart ? 3 : 4"
              :class="{
                'pa-0 px-2': !$vuetify.breakpoint.smAndUp
              }"
            >
              <PaymentCard ref="cardForm" v-if="cardPaymentObj" :cardPaymentObj="cardPaymentObj" @payment-succeess="paymentSuccess"></PaymentCard>

              <!-- <v-card class="mb-12" color="grey lighten-1" height="200px"></v-card> -->
              <!-- <v-btn color="primary" @next-step="currentStep++">Continue</v-btn> -->
              <!-- <v-btn text>Cancel</v-btn> -->
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </LayoutContent>
      <bottom-bar v-show="bottom">
        <v-container class="py-3 d-flex align-center justify-space-between">
          <div
            class="d-flex"
            :class="{
              'flex-row': $vuetify.breakpoint.smAndUp,
              'flex-column': !$vuetify.breakpoint.smAndUp
            }"
          >
            <span
              class="white--text font-weight-bold"
              :class="{
                'mr-10': $vuetify.breakpoint.smAndUp
              }"
            >
              {{ $t('label.totalPayment') }}:
            </span>
            <span class="white--text font-weight-bold mr-auto">{{ orderSummary.currency }} {{ formatAmount(orderSummary.total) }}</span>
          </div>
          <app-button :label="nextStepName" @click="nextStep" v-if="!hideButton" />
        </v-container>
      </bottom-bar>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'

import PaymentCard from '@/components/checkout/PaymentCard.vue'
import LayoutContent from '@/views/layouts/LayoutContent'
import Checkout from '@/components/checkout/Checkout'
import SectionTitle from '@/components/SectionTitle.vue'
import ArrangeDelivery from '@/components/checkout/ArrangeDelivery.vue'
import PaymentMethods from '@/components/checkout/PaymentMethods.vue'
import { localeHelper } from '@/utils'
import { PURCHASE } from '@/api/purchase.api'
import { PAYMENT } from '@/api/payment.api'
import { uiHelper } from '@/utils'
import Config from '@/config.json'

export default {
  name: 'CheckOut',
  components: {
    LayoutContent,
    Checkout,
    SectionTitle,
    ArrangeDelivery,
    PaymentMethods,
    PaymentCard
  },
  props: { step: { type: Number, default: 1 } },
  data() {
    return {
      stripe: Stripe(Config.VUE_APP_STRIPE),
      steps: [
        { title: localeHelper.getMessage('label.checkOut') },
        { title: localeHelper.getMessage('label.arrangeDelivery') },
        { title: localeHelper.getMessage('label.selectPaymentMethod') },
        { title: localeHelper.getMessage('label.makePayment') },
        { title: localeHelper.getMessage('label.pay') }
      ],
      currentStep: this.step,
      deliveryDate: '',
      deliveryTIme: '',
      poNumber: '',
      popup: null,
      paymentComplete: false,
      abortController: new AbortController(),
      editAddressCountry: false,
      selectedMethod: '',
      cardPaymentObj: [],
      showloading: false
    }
  },

  beforeMount() {
    if (this.step !== 2) {
      this.resetArrangeDelivery()
    }
    if (this.voucherOnlyCart) {
      this.steps.splice(1, 1)
    }
  },

  mounted() {
    window.addEventListener('message', this.handlePaymentMessage, { signal: this.abortController.signal }, true)
  },

  computed: {
    ...mapState('auth', ['addressList']),
    ...mapState('order', ['itemsForCheckout', 'orderSummary', 'arrangeDelivery', 'orderCompletedDay']),
    ...mapGetters('order', ['voucherOnlyCart']),
    sectionTitle() {
      let title = this.steps[this.currentStep - 1].title
      if (this.currentStep === 1) {
        title += ` (${this.itemsForCheckout.length})`
      }
      return title
    },

    nextStepName() {
      let label = ''
      if (this.currentStep < this.steps.length) {
        label = this.steps[this.currentStep].title
      }
      return label
    },

    bottom() {
      if (this.currentStep == 3) {
        if (this.arrangeDelivery.date == '' || this.arrangeDelivery.time == '' || this.addressList.length == 0) {
          return false
        }
      }
      return true
    },
    hideButton() {
      if (!this.voucherOnlyCart) {
        if (this.currentStep == 2) {
          if (this.arrangeDelivery.date == '' || this.arrangeDelivery.time == '' || this.addressList.length == 0) {
            return true
          }
        } else if (this.currentStep == 3) {
          if (this.selectedMethod === '') return true
        }
      } else {
        if (this.currentStep == 2) if (this.selectedMethod === '') return true
      }
      return false
    }
  },

  watch: {
    currentStep() {
      this.$el.querySelector('#checkout-anchor').scrollIntoView()
    }
  },

  methods: {
    ...mapMutations('order', ['resetCheckoutItem', 'resetArrangeDelivery']),
    async nextStep() {
      if (this.currentStep == 1) {
        this.currentStep++
      } else if (this.currentStep == 2) {
        if (this.orderSummary.total < 1.5 && this.selectedMethod.paymentMethod === 'atome') this.$toast.error(this.$t('error.paymentMethodUnsupported'))
        else {
          let date = this.arrangeDelivery.date
          let time = this.arrangeDelivery.time
          PURCHASE.placeOrder({ date, time })
            .then((res) => {
              this.poNumber = res.po_number
              this.currentStep++
            })
            .catch(({ error_message }) => {
              this.$toast.error(error_message)
              if (error_message === 'Invalid delivery address country.') this.editAddressCountry = true
            })
        }
      } else {
        if (this.selectedMethod.value === 'atome') {
          this.popup = window.open()
          PAYMENT.makePayment(this.poNumber, this.selectedMethod).then((paymentRes) => {
            let url = null
            if (this.selectedMethod.value === 'atome') {
              url = paymentRes.redirect_url
            } else {
              url = URL.createObjectURL(new Blob([paymentRes], { type: 'text/html' }))
            }
            this.popup.location = url
            var popupTick = setInterval(() => {
              if (this.popup.closed) {
                clearInterval(popupTick)
                this.abortController.abort()
                if (!this.paymentComplete) this.$router.push({ name: this.$constants.ROUTE_NAME.ORDER_LIST, params: { id: 1 } })
              }
            }, 500)
          })
        } else if ((this.selectedMethod.value === 'stripe' || this.selectedMethod.value === 'stripeGrab') && this.currentStep == 3) {
          PAYMENT.makeStripePayment(this.poNumber, this.selectedMethod.paymentMethod).then((response) => {
            if (response) {
              this.cardPaymentObj = response
              if (this.selectedMethod.value === 'stripe') {
                this.currentStep = 4
              } else {
                this.processCheckOut()
              }
            }
          })
        } else {
          this.processCheckOut()
        }
      }
    },
    processCheckOut() {
      if (this.selectedMethod.value === 'stripe' && this.currentStep == 4) {
        this.$refs.cardForm.submit()
      } else if (this.selectedMethod.value === 'stripeGrab') {
        var hostname = window.location.origin
        this.showloading = true
        this.stripe.confirmGrabPayPayment(this.cardPaymentObj.client_secret, {
          // Return URL where the customer should be redirected to after the authorization
          return_url: `${hostname}/order`
        })
      }
    },
    async paymentSuccess() {
      let value = this.cardPaymentObj
      await PAYMENT.paymentSeccess(value).then((response) => {
        if (response) {
          this.$router.push({ name: this.$constants.ROUTE_NAME.ORDER_PAYMENT_SUCCESS, query: { po_number: this.poNumber } })
        }
      })
    },
    formatAmount(amount) {
      return uiHelper.priceFormatter(amount)
    },
    handlePaymentMessage(event) {
      const data = event.data
      if (data.status && this.popup != null) {
        this.paymentComplete = true
        if (data.status == 'success') {
          this.$router.push({ name: this.$constants.ROUTE_NAME.ORDER_PAYMENT_SUCCESS, query: { po_number: this.poNumber } })
        }
        if (data.status == 'fail') {
          this.$router.push({ name: this.$constants.ROUTE_NAME.ORDER_LIST, params: { id: 1 } })
        }
        this.popup.close()
        this.resetCheckoutItem()
      }
    },
    onPaymentMethodSelected(val) {
      this.selectedMethod = val
    }
  },

  beforeRouteLeave(to, from, next) {
    window.removeEventListener('message', this.handlePaymentMessage)
    next()
  }
}
</script>

<style lang="scss" scoped>
.checkout-flow--stepper ::v-deep {
  --stepper-radius: 1.2rem;
  // max-width: 900px;
  height: auto;
  margin-left: auto;
  margin-right: auto;

  .v-icon {
    background-color: unset !important;
  }

  .v-divider {
    margin-top: calc(24px + var(--stepper-radius)) !important;
  }

  .v-stepper__step__step {
    width: calc(var(--stepper-radius) * 2);
    height: calc(var(--stepper-radius) * 2);
    font-size: 1.4rem;
    margin-bottom: 0.6rem;
    @include green-gradient(180deg);
  }
  .v-stepper__step--inactive .v-stepper__step__step {
    background: white !important;
    border: 1px solid var(--v-secondary-lighten4);
    color: var(--v-secondary-lighten2);
  }

  .v-stepper__label {
    text-align: center;
    white-space: nowrap;
  }
}
</style>
